import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AjaxPlugin } from '@microsoft/applicationinsights-dependencies-js';

let environment = 'development';
let appVersion = '1.0.0';

export let appInsights: ApplicationInsights; // exported but only initialized later

export function initializeTelemetry(config: { instrumentationKey: string; environment: string; version: string; cloudRolename: string; }) {
    appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: config.instrumentationKey,
            enableAutoRouteTracking: true,
            extensions: [new AjaxPlugin()],
            extensionConfig: {
                [AjaxPlugin.identifier]: {
                    autoTrackFetch: true,
                    autoTrackAjax: true,
                }
            }
        }
    });

    appInsights.loadAppInsights();

    environment = config.environment || environment;
    appVersion = config.version || appVersion;

    // Track uncaught errors
    window.addEventListener('error', (event) => {
        appInsights.trackException({
            exception: event.error || new Error(event.message),
            severityLevel: 3,
        });
    });

    window.addEventListener('unhandledrejection', (event) => {
        appInsights.trackException({
            exception: event.reason instanceof Error ? event.reason : new Error(String(event.reason)),
            severityLevel: 3,
        });
    });

    // Add common dimensions
    appInsights.addTelemetryInitializer((envelope) => {
        const tags = envelope?.tags;
        if (tags) {
            tags['ai.cloud.role'] = config.cloudRolename;
        }
        if (envelope.data && envelope.data.baseData) {
            const baseData = envelope.data.baseData as any;
            baseData.properties = {
                ...(baseData.properties || {}),
                UserId: localStorage.getItem('userId') || 'anonymous',
                AppVersion: appVersion,
                Environment: environment,
            };
        }
    });
}
